// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2072":"4dfa2e3f2030ae9f","7694":"3dea10dfa1101969"}[chunkId] + ".css";
};